import { put, select } from 'redux-saga/effects';
import { Types } from '../getScheduleUseCase/actions';
import DateHelpers from '../../../../core/helpers/DateHelper';

import {
  findWeek,
  findModule,
  findVirtualMeetingsByWeek,
  findGlobalMeetingsByWeek,
  findAcademicCalendar
} from '../getScheduleUseCase/saga';
import constants from '../../../../core/constants';

export default function* execute(action: any): any {
  try {
    const schedule = yield select((state: any) => state.schedule.data);
    const {
      virtualMeetingsAll,
      availableDays,
      modules,
      meetingsGlobal,
      weeks,
      academicCalendar
    } = schedule;

    const { date } = action;
    const w = DateHelpers.getFirstDayOfWeekFromTimestamp(date.getTime());
    const firstDayOfWeek = w.getTime();
    const newDates = availableDays.map((numberDay: number) =>
      DateHelpers.addDays(new Date(firstDayOfWeek), numberDay - 1)
    );

    const newSchedule = findGlobalMeetingsByWeek(meetingsGlobal, newDates);

    const weekRow = findWeek(date, weeks); // week;
    const firstDateOfWeek = DateHelpers.formatMonthDate(
      weekRow.start + constants.MIL_PERU
    );
    const lastDateOfWeek = DateHelpers.formatMonthDate(
      weekRow.end + constants.MIL_PERU
    );
    const academic = yield select(
      (state: any) => state.profile?.data?.academic
    );
    const virtualMeetingsByWeek = findVirtualMeetingsByWeek(
      virtualMeetingsAll,
      newDates[0].getTime(),
      academic
      // weekRow.start
    );
    const currentModule = findModule(newDates[0]?.getTime(), modules);
    const newAcademicCalendarByWeek = findAcademicCalendar(
      newDates,
      academicCalendar,
      date
    );
    const data = {
      ...schedule,
      virtualMeetings: virtualMeetingsByWeek,
      dates: newDates,
      schedule: newSchedule,
      firstDayOfWeek: newDates[0],
      firstDateOfWeek,
      lastDateOfWeek,
      weekId: weekRow.weekId,
      initialWeekTitle: weekRow.name,
      currentModule,
      selectedDate: date,
      academicCalendarByWeek: newAcademicCalendarByWeek
    };
    yield put({
      type: Types.GET_SCHEDULE_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: Types.GET_SCHEDULE_FAILURE,
      error: 'Ocurrió un error'
    });
  }
}
